import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  AfterViewInit
} from '@angular/core';

import { CapacitacionService } from '../../../services/capacitacion.service';
import { NavigationService } from '../../../services/navigation.service';
import { MONTHS, MONTHS_BD } from '../../../utils/constants';
import { ZoneService } from 'src/app/services/zone.service';
import { EventEmitterService } from 'src/app/services/event-emitter.service';
import { EventYearService } from 'src/app/services/event-year.service';
import { EventMonthService } from 'src/app/services/event-month.service';
import { ExcelService } from 'src/app/services/excel.service';
import { ToastrService } from 'ngx-toastr';
import { EvidenciaService } from 'src/app/services/evidencia.service';
import { CategoryService } from '../../../services/category.service';
import { EnfoqueService } from '../../../services/enfoque.service';
import { EjecutorService } from '../../../services/ejecutor.service';
import { ValidationService } from '../../../services/validation.service';
import { LoginService } from 'src/app/services/login.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: "app-table-view",
  templateUrl: "./table-view.component.html",
  styleUrls: ["./table-view.component.scss"],
})
export class TableViewComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() searchText: any;

  loading = false;
  rolid: any;

  year: number = new Date().getFullYear();
  month: number | null = null;
  contratista = "";
  empresa = "";
  zona = "";

  monthDB = [];
  yearsDB: number[] = [];

  rows: any[] = [];
  rowsOriginal: any[] = [];
  rowsAssitance: any[] = [];
  zonas: any[] = [];

  page = 1;
  pageSize = 10;
  totalAmmount = 0;
  sizeOptions = [
    { value: 10, label: "10 por página" },
    { value: 20, label: "20 por página" },
    { value: 50, label: "50 por página" },
  ];

  filtrando = false;
  searchT = "";

  capacitacionModalMode: string;
  capacitacionSelected: any;
  capacitacionSelectedWorkers: any;
  capacitacionSelectedWorkersIds: any;
  capacitacionIdSelected: number;

  confirmationModalTittle: string;
  confirmationModalMessage: string;
  confirmationModalHasComment = false;
  confirmationModalHasOptions = false;
  confirmationModalisCommentObligatory = false;
  confirmationModalOptionLabel = "Motivo";
  confirmationModalOptions: { label: string; value: any }[] = [
    { label: "No corresponde a actividad de capacitación", value: 1 },
    { label: "Actividad fuera del foco", value: 2 },
    { label: "Actividad no cumple los requerimientos en la forma", value: 3 },
    { label: "Cancelado", value: 4 },
    { label: "Actividad fuera del foco", value: 5 },
  ];
  confirmationModalAccept: any;

  categoriesWithFocos: any;
  enfoques: any;
  ejecutoresWithRelatores: any;
  evidencesCount: any;

  constructor(
    private capacitacionService: CapacitacionService,
    private navigationService: NavigationService,
    private excelService: ExcelService,
    private eventMonthService: EventMonthService,
    private eventYearService: EventYearService,
    private categoryService: CategoryService,
    private enfoqueService: EnfoqueService,
    private ejecutorService: EjecutorService,
    private validationService: ValidationService,
    private zoneService: ZoneService,
    private evidenciaService: EvidenciaService,
    private toastr: ToastrService,
    private eventEmitterService: EventEmitterService,
    private loginService: LoginService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.loadYear();
    if (this.eventEmitterService.subsFirst == undefined) {
      this.eventEmitterService.subsFirst =
        this.eventEmitterService.invokeFirstComponentFunction.subscribe(
          (_name: string) => {
            this.resetToFirstPageAndRefetch();
          }
        );
    }
    if (this.eventYearService.subsVar == undefined) {
      this.eventYearService.subsVar =
        this.eventYearService.invokeFirstComponentFunction.subscribe(
          (year: string) => {
            const y = Number(year);
            this.year = isNaN(y) ? this.year : y;
            this.resetToFirstPageAndRefetch();
          }
        );
    }
    if (this.eventMonthService.subsVar == undefined) {
      this.eventMonthService.subsVar =
        this.eventMonthService.invokeFirstComponentFunction.subscribe(
          (month: string) => {
            const m = month === "" ? null : Number(month);
            this.month = m === null || isNaN(m) ? null : m;
            this.resetToFirstPageAndRefetch();
          }
        );
    }

    this.getZonas();

    if (!this.navigationService.getValidLogin())
      this.navigationService.goTo("/login");

    this.fetchCapacitaciones(
      this.year,
      this.toStrMonth(this.month),
      this.contratista,
      this.empresa,
      this.zona
    );

    this.categoryService
      .listWithFocos()
      .then((r) => (this.categoriesWithFocos = r))
      .catch(console.error);
    this.enfoqueService
      .list()
      .then((r) => (this.enfoques = r))
      .catch(console.error);
    this.ejecutorService
      .listWithRelatores()
      .then((r) => (this.ejecutoresWithRelatores = r))
      .catch(console.error);
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  loadYear(): void {
    const current = new Date().getFullYear();
    this.yearsDB = [];
    for (let y = 2019; y <= current; y++) this.yearsDB.push(y);
    this.monthDB = [...MONTHS_BD];
  }

  toStrMonth(m: number | null): string {
    return m == null ? "" : String(m);
  }

  getZonas(): any {
    return new Promise((resolve, reject) => {
      this.zoneService
        .getZonas()
        .then((response) => {
          this.zonas = response;
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  }

  getMonthLabel(id: number): string {
    console.log(id)
    const idx = id - 1;
    return MONTHS[idx].label;
  }

  onPageChange(newPage: number): void {
    this.page = newPage;
    this.fetchCapacitaciones(
      this.year,
      this.toStrMonth(this.month),
      this.contratista,
      this.empresa,
      this.zona
    );
  }

  onPageSizeChange(): void {
    this.page = 1;
    this.fetchCapacitaciones(
      this.year,
      this.toStrMonth(this.month),
      this.contratista,
      this.empresa,
      this.zona
    );
  }

  private resetToFirstPageAndRefetch(): void {
    this.page = 1;
    this.fetchCapacitaciones(
      this.year,
      this.toStrMonth(this.month),
      this.contratista,
      this.empresa,
      this.zona
    );
  }

  fetchCapacitaciones(
    year: number,
    month: string,
    contratista: string,
    empresa: string,
    zona: string
  ): void {
    this.loading = true;

    this.loginService.obtenerPermisosMenu("planificacion").then((response) => {
      this.rolid = response.data.rolId;
    });

    this.capacitacionService
      .getTotalAmmout(String(year), month, contratista, empresa, zona)
      .then((total) => (this.totalAmmount = total))
      .catch(console.error);

    this.capacitacionService
      .listPagination(
        this.page,
        this.pageSize,
        String(year),
        month,
        contratista,
        empresa,
        zona
      )
      .then((resp) => {
        const content = resp.content || resp.items || resp.data || [];
        this.rowsOriginal = content;
        this.rows = content.map((c) => this.buildRow(c));
        this.rowsAssitance = content.map((c) => c.assistanceRegistries);

        if (resp.totalElements != null) this.totalAmmount = resp.totalElements;
        if (resp.total != null) this.totalAmmount = resp.total;

        this.loading = false;
      })
      .catch((error) => {
        console.error(error);
        this.loading = false;
      });
  }

  getCapacitaciones(): void {
    // al cambiar filtros desde los selects, resetea a página 1
    this.resetToFirstPageAndRefetch();
  }

  //   export(): void {
  //     this.excelService.downloadCapacitaciones({
  //       String(year),
  // month, roleId, userId, empresaId, this.page, this.pageSize
  //     });

  //   }

  changeSearch(e: any): void {
    const valor: string = e.target.value;
    if (valor.trim().length === 0) {
      this.filtrando = false;
      return;
    }
    this.filtrando = true;

    const word = valor.toLowerCase();
    this.rows = this.rowsOriginal
      .map((c) => this.buildRow(c))
      .filter((item: any) => {
        const str =
          (item.capacitacion.zoneDescription || "") +
          (item.capacitacion.nombreContratista || "") +
          (item.capacitacion.nombreTrabajador || "") +
          (item.capacitacion.name || "");
        return str.toLowerCase().includes(word);
      });
  }

  openInformationModal(modal: any, capacitacion: any, workers: any): void {
    this.capacitacionModalMode = "read";
    this.capacitacionSelected = JSON.parse(JSON.stringify(capacitacion));
    this.capacitacionSelectedWorkers = JSON.parse(JSON.stringify(workers));
    this.capacitacionSelectedWorkersIds = (workers || []).map(
      (w) => w.rutTrabajador
    );
    this.openModal(modal, { size: "lg" });
  }

  openEditionModal(modal: any, capacitacion: any, workers: any): void {

    console.log(workers)

    this.capacitacionModalMode = "edit";
    capacitacion.statusCapacitacionLabel = capacitacion.stateShortDescription;
    this.capacitacionSelected = JSON.parse(JSON.stringify(capacitacion));
    this.capacitacionSelectedWorkers = JSON.parse(JSON.stringify(workers));
    this.capacitacionSelectedWorkersIds = (workers || []).map(
      (w) => w.rutTrabajador
    );
    this.openModal(modal, { size: "lg" });
  }

  openDeleteModal(modal: any, capacitacion: any): void {
    if (this.validationService.canDelete(capacitacion, String(this.rolid))) {
      this.confirmationModalHasComment = false;
      this.confirmationModalHasOptions = false;
      this.confirmationModalisCommentObligatory = false;
      this.capacitacionIdSelected = capacitacion.capacitacionId;
      this.confirmationModalTittle = "Eliminar capacitación";
      this.confirmationModalMessage = `¿Seguro que desea eliminar la capacitación "${capacitacion.name}"?`;
      this.confirmationModalAccept = this.onDeleteCapacitacion.bind(this);
      this.openModal(modal);
    }
  }

  async openAcceptModal(
    modal: any,
    capacitacion: any,
    workers: any,
    editionModal: any
  ): Promise<void> {
    if (
      this.validationService.canAcceptOrReject(
        capacitacion,
        String(this.rolid)
      ) ||
      this.validationService.canClose(capacitacion, String(this.rolid))
    ) {
      this.confirmationModalHasOptions = false;
      this.confirmationModalisCommentObligatory = false;
      this.capacitacionIdSelected = capacitacion.capacitacionId;

      if (
        this.validationService.canAcceptOrReject(
          capacitacion,
          String(this.rolid)
        )
      ) {
        this.confirmationModalTittle = "Aprobar capacitación";
        this.confirmationModalMessage = `¿Seguro que desea aprobar la capacitación "${capacitacion.name}"?`;
        this.confirmationModalHasComment = true;
        this.confirmationModalAccept = this.onAcceptCapacitacion.bind(this);
        this.openModal(modal);
        return;
      } else {
        this.evidencesCount = 0;
        await this.fetchEvidencia(capacitacion);
        if (
          ((Number.parseInt(capacitacion.realHours) || 0) > 0 &&
            (Number.parseInt(capacitacion.realAssistants) || 0) > 0 &&
            this.evidencesCount > 0 &&
            capacitacion.realExecutionDate) ||
          capacitacion.capacitacionTypeId == 2
        ) {
          this.confirmationModalTittle = "Cerrar capacitación";
          this.confirmationModalMessage = `¿Seguro que desea cerrar la capacitación "${capacitacion.name}"?`;
          this.confirmationModalHasComment = true;
          this.confirmationModalAccept = this.onAcceptCapacitacion.bind(this);
          this.openModal(modal);
          return;
        } else {
          if (this.validationService.canEdit(capacitacion)) {
            this.capacitacionModalMode = "edit";
            this.capacitacionSelected = JSON.parse(
              JSON.stringify(capacitacion)
            );
            this.capacitacionSelectedWorkers = JSON.parse(
              JSON.stringify(workers)
            );
            this.capacitacionSelectedWorkersIds = (workers || []).map(
              (w) => w.rutTrabajador
            );
            this.openModal(editionModal, { size: "lg" });
            this.toastr.info(
              "Actualiza: Duración Real, Asistentes Reales, Evidencia y Fecha Ejecución Real antes de cerrar",
              "Advertencia"
            );
            return;
          }
        }
      }
    }
  }

  async fetchEvidencia(capacitacion: any) {
    try {
      const evidencias = await this.evidenciaService.list(
        capacitacion.capacitacionId
      );
      this.evidencesCount = evidencias.evidencias.length || 0;
    } catch (error) {
      console.error(error);
    }
  }

  openRejectModal(modal: any, capacitacion: any): void {
    if (
      this.validationService.canAcceptOrReject(capacitacion, String(this.rolid))
    ) {
      this.confirmationModalHasComment = true;
      this.confirmationModalHasOptions = true;
      this.confirmationModalisCommentObligatory = true;
      this.capacitacionIdSelected = capacitacion.capacitacionId;
      this.confirmationModalTittle = "Rechazar capacitación";
      this.confirmationModalMessage = `¿Seguro que desea rechazar la capacitación "${capacitacion.name}"?`;
      this.confirmationModalAccept = this.onRejectCapacitacion.bind(this);
      this.openModal(modal);
    }
  }

  openModal(modal: any, options: any = {}): void {
    const modalOptions = {
      ariaLabelledBy: "modal-basic-title",
      centered: true,
      ...options,
    };
    this.modalService.open(modal, modalOptions);
  }

  onDeleteCapacitacion(): void {
    this.capacitacionService
      .delete(this.capacitacionIdSelected)
      .then(() => this.resetToFirstPageAndRefetch())
      .catch(console.error);
  }

  onAcceptCapacitacion(comment: string): void {
    this.capacitacionService
      .accept(
        this.capacitacionIdSelected,
        sessionStorage.getItem("userid"),
        "0",
        comment
      )
      .then(() => {})
      .catch(console.error);
  }

  onRejectCapacitacion(comment: string, option: any): void {
    this.capacitacionService
      .reject(
        this.capacitacionIdSelected,
        sessionStorage.getItem("userid"),
        option,
        comment
      )
      .then(() => {})
      .catch(console.error);
  }

  buildRow(c: any): any {
    const cells = [
      { class: "td-centered", tooltip: false, content: c.capacitacion.capacitacionId },
      { class: "td-centered", tooltip: false, content: c.capacitacion.zoneDescription },
      {
        class: "td-centered",
        tooltip: false,
        content: c.capacitacion.capacitacionTypeDescription,
      },
      { class: "td-full", tooltip: true, content: c.capacitacion.name },
      { class: "td-truncated", tooltip: true, content: c.capacitacion.categoryDescription },
      { class: "td-truncated", tooltip: true, content: c.capacitacion.focoDescription },
      { class: "td-centered", tooltip: false, content: c.capacitacion.ejecutorDescription },
      {
        class: "td-centered",
        tooltip: false,
        content: this.getMonthLabel(c.capacitacion.month),
      },
      {
        class: "td-centered",
        tooltip: false,
        content: c.capacitacion.stateShortDescription,
      },
    ];


    console.log({
      capacitacion: c.capacitacion,
      workers: c.assistanceRegistries,
      id: c.capacitacion.capacitacionId,
      status: c.capacitacion.stateShortDescription,
      type: c.capacitacion.capacitacionTypeDescription,
      month: this.getMonthLabel(c.capacitacion.month),
      year: c.capacitacion.year,
      zone: c.capacitacion.zone,
      cells,
    })

    return {
      capacitacion: c.capacitacion,
      workers: c.assistanceRegistries,
      id: c.capacitacion.capacitacionId,
      status: c.capacitacion.stateShortDescription,
      type: c.capacitacion.capacitacionTypeDescription,
      month: this.getMonthLabel(c.capacitacion.month),
      year: c.capacitacion.year,
      zone: c.capacitacion.zone,
      cells
    };
  }

  exports(option: "all" | "current" | number) {
    if (typeof option === "number") {
      console.log(`Exportando página ${option}`);
      const obj = {
        year: String(this.year),
        month:
          this.month === null || this.month === 0 ? "all" : String(this.month),
        roleId: null,
        userId: null,
        empresaId: null,
        page: option,
        size: this.pageSize,
      };

      this.export(obj);
    } else if (option === "all") {
      console.log("Exportando todos los registros...");
      const obj = {
        year: String(this.year),
        month:
          this.month === null || this.month === 0 ? "all" : String(this.month),
        roleId: null,
        userId: null,
        empresaId: null,
        size: 0
      };

      this.export(obj);
    } else if (option === "current") {
      console.log("Exportando página actual...");

      const obj = {
        year: String(this.year),
        month:
          this.month === null || this.month === 0 ? "all" : String(this.month),
        roleId: null,
        userId: null,
        empresaId: null,
        page: this.page,
        size: this.pageSize,
      };

      this.export(obj);
    }
  }

  exportSpecificPage() {
    const input = prompt("Ingrese el número de página a exportar:");
    const page = Number(input);
    if (!isNaN(page) && page > 0) {

        const obj = {
        year: String(this.year),
        month:
          this.month === null || this.month === 0 ? "all" : String(this.month),
        roleId: null,
        userId: null,
        empresaId: null,
        page: page,
        size: this.pageSize,
      };
      this.export(obj);
    }
  }

  export(obj): void {
    console.log(obj);
    console.log(JSON.stringify(obj));
    this.excelService.downloadCapacitaciones(obj).subscribe({
      next: () => console.log("Descarga iniciada correctamente"),
      error: (err) => {
        console.error("Error al descargar el Excel:", err);
        alert(err.message || "Ocurrió un error al generar el reporte.");
      },
    });
  }
}
